import React from "react";
import { DatePicker, Row, Col, Card, Progress, Spin, Empty, Divider, Icon } from "antd";
import { connect } from "react-redux";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
import moment from "moment";
import Request from "../../request";
import { FaGlobeAmericas, FaCheckCircle, FaUserPlus, FaChartLine } from "react-icons/fa";

const { RangePicker } = DatePicker;

class VisaDepartmentReport extends React.Component {
    state = {
        time: { from: null, to: null },
        countryArr: {},
        report: null,
        loading: false
    };

    componentDidMount() {
        this.loadCountries();
    }

    loadCountries = async (params = {}) => {
        params.results = 100;
        let response = await Request.getCountriesWithoutAuth(params);
        let data = response && response.data ? response.data : [];
        let countries = {};
        data.forEach(item => { countries[item._id] = item.countryName; });
        this.setState({ countryArr: countries });
    };

    loadData = async (params = {}) => {
        this.setState({ loading: true });
        if (this.state.time.from && this.state.time.to) {
            params.time = this.state.time;
        }
        let response = await Request.getVisaDepartmentReport(params);
        this.setState({
            report: response && response.data ? response.data : null,
            loading: false
        });
    };

    chooseRangerPicker = (date) => {
        if (!date || !date[0] || !date[1]) {
            this.setState({ time: { from: null, to: null }, report: null });
            return;
        }
        this.setState({
            time: {
                from: moment(date[0]).startOf("day"),
                to: moment(date[1]).endOf("day")
            }
        }, () => this.loadData());
    };

    getPercentageColor = (value) => {
        if (value >= 75) return "#52c41a";
        if (value >= 50) return "#faad14";
        return "#f5222d";
    };

    render() {
        const { report, countryArr, loading } = this.state;

        // Functional check logic (Keep exactly as your previous version)
        let hasOverallData = false;
        let hasCountryData = false;
        if (report && report.overall) {
            hasOverallData = report.overall.totalRegistrations > 0;
        }
        if (report && report.countryWise && report.countryWise.length > 0) {
            hasCountryData = true;
        }
        let hasAnyData = hasOverallData || hasCountryData;

        // UI Style Constants
        const cardStyle = {
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
            border: "none"
        };

        return (
            <PageHeaderWrapper title="Visa Department Analytics">

                {/* FILTER */}
                <Card bordered={false} style={{ ...cardStyle, marginBottom: 24 }}>
                    <Row type="flex" align="middle" gutter={16}>
                        <Col>
                            <strong style={{ marginRight: 12 }}>Period:</strong>
                            <RangePicker
                                format="YYYY-MM-DD"
                                onChange={this.chooseRangerPicker}
                                style={{ width: 300 }}
                            />
                        </Col>
                        {loading && (
                            <Col>
                                <Spin indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />} />
                            </Col>
                        )}
                    </Row>
                </Card>

                {/* NO DATE SELECTED (Original functionality) */}
                {!report && !loading && (
                    <Card bordered={false} style={{ ...cardStyle, textAlign: "center", padding: "60px 0" }}>
                        <Empty description="Please select a date range to view the report" />
                    </Card>
                )}

                {/* NO DATA FOUND (Original functionality) */}
                {report && !hasAnyData && !loading && (
                    <Card bordered={false} style={{ ...cardStyle, textAlign: "center", padding: "60px 0" }}>
                        <Empty description="No data found for selected period" />
                    </Card>
                )}

                {/* DATA AVAILABLE UI */}
                {report && hasAnyData && (
                    <div>
                        {/* OVERALL SUMMARY */}
                        <Row gutter={24}>
                            <Col span={8}>
                                <Card bordered={false} style={cardStyle}>
                                    <div style={{ color: "#8c8c8c", marginBottom: 8 }}>Visas Applied</div>
                                    <h2 style={{ margin: 0, display: "flex", alignItems: "center" }}>
                                        <FaUserPlus style={{ color: "#1890ff", marginRight: 12 }} />
                                        {report.overall.totalRegistrations}
                                    </h2>
                                </Card>
                            </Col>

                            <Col span={8}>
                                <Card bordered={false} style={cardStyle}>
                                    <div style={{ color: "#8c8c8c", marginBottom: 8 }}>Visas Approved</div>
                                    <h2 style={{ margin: 0, color: "#52c41a", display: "flex", alignItems: "center" }}>
                                        <FaCheckCircle style={{ marginRight: 12 }} />
                                        {report.overall.approved}
                                    </h2>
                                </Card>
                            </Col>

                            <Col span={8}>
                                <Card bordered={false} style={cardStyle}>
                                    <div style={{ color: "#8c8c8c", marginBottom: 8 }}>Success Rate</div>
                                    <h2 style={{ margin: 0, color: this.getPercentageColor(report.overall.successPercentage), display: "flex", alignItems: "center" }}>
                                        <FaChartLine style={{ marginRight: 12 }} />
                                        {report.overall.successPercentage}%
                                    </h2>
                                    {/* <Progress
                                        percent={report.overall.successPercentage}
                                        showInfo={false}
                                        strokeWidth={8}
                                        strokeColor={this.getPercentageColor(report.overall.successPercentage)}
                                        style={{ marginTop: 10 }}
                                    /> */}
                                </Card>
                            </Col>
                        </Row>

                        {/* COUNTRY PERFORMANCE */}
                        {hasCountryData && (
                            <React.Fragment>
                                <Divider orientation="left" style={{ margin: "40px 0 24px" }}>
                                    <span style={{ fontWeight: 600, color: "#555" }}>Country Performance</span>
                                </Divider>

                                <Row gutter={[24, 24]}>
                                    {report.countryWise.map(item => (
                                        <Col span={6} key={item.countryId}>
                                            <Card bordered={false} hoverable style={cardStyle}>
                                                <div style={{ marginBottom: 16, fontWeight: 700, fontSize: "15px" }}>
                                                    <FaGlobeAmericas style={{ marginRight: 10, color: "#08979c" }} />
                                                    {countryArr[item.countryId] || "Unknown"}
                                                </div>

                                                <Row>
                                                    <Col span={12}>
                                                        <div style={{ color: "#8c8c8c", fontSize: "12px" }}>Applied</div>
                                                        <strong style={{ fontSize: "16px" }}>{item.totalRegistrations}</strong>
                                                    </Col>
                                                    <Col span={12}>
                                                        <div style={{ color: "#8c8c8c", fontSize: "12px" }}>Approved</div>
                                                        <strong style={{ fontSize: "16px", color: "#52c41a" }}>{item.approved}</strong>
                                                    </Col>
                                                </Row>

                                                <div style={{ marginTop: 16, paddingTop: 16, borderTop: "1px solid #f0f0f0" }}>
                                                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                                                        <span style={{ fontSize: "12px" }}>Success</span>
                                                        <strong style={{ color: this.getPercentageColor(item.successPercentage) }}>
                                                            {item.successPercentage}%
                                                        </strong>
                                                    </div>
                                                    <Progress
                                                        percent={item.successPercentage}
                                                        size="small"
                                                        strokeWidth={6}
                                                        strokeColor={this.getPercentageColor(item.successPercentage)}
                                                        showInfo={false}
                                                    />
                                                </div>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                            </React.Fragment>
                        )}
                    </div>
                )}
            </PageHeaderWrapper>
        );
    }
}

const mapStateToProps = ({ global }) => ({
    loading: global.buttonLoading
});

export default connect(mapStateToProps)(VisaDepartmentReport);